import zip from "lodash/zip";
import { ErrorDisplay } from "@ploy-lib/types";
export const fieldToKey = (f) => `${f.namespace}.${f.name}.${f.renderAs}.${f.formTemplateFieldId}`;
export const sectionToKey = (formTemplateSectionId, index) => `${formTemplateSectionId}.${index}`;
export function cssContains(...classes) {
    return (text) => classes.filter(i => i != null).some(c => c.includes(text));
}
export const isNotLiteral = (item) => !item.literal;
export const isTouchyLiteralOrNotLiteral = (item) => !item.literal || item.errorDisplayLiteral === ErrorDisplay.Touched;
export const mapToPaths = (obj) => Object.entries(obj).flatMap(([k, v]) => typeof v === "object" ? mapToPaths(v).map(p => `${k}.${p}`) : k);
export const RIC = typeof globalThis.requestIdleCallback === "function"
    ? globalThis.requestIdleCallback
    : cb => globalThis.setTimeout(cb, 0);
export const idle = (options) => new Promise(resolve => RIC(resolve, options));
export const zipWithPeek = (data) => data.length > 0 ? zip(data, [...data.slice(1), null]) : [];
export const tupleToType = (...args) => args;
export function extractFieldsWithRoles(wantedRoles, fields) {
    const candidates = fields.reduce((o, f) => {
        if (f.role && wantedRoles.includes(f.role) && !o[f.role])
            o[f.role] = f;
        return o;
    }, {});
    return candidates;
}
export function extractCalcDataFromFieldsWithRoles(wantedRoles, fields, calcData) {
    const candidates = fields.reduce((o, f, i) => {
        if (f.role && wantedRoles.includes(f.role) && !o[f.role]) {
            const data = calcData[i];
            if (data && data.visible) {
                const { fieldValue, value } = data;
                o[f.role] = value !== undefined ? value : fieldValue;
            }
        }
        return o;
    }, {});
    return candidates;
}
export function isNotNull(x) {
    return x != null;
}
export function secondValueIsNotNull(vals) {
    return isNotNull(vals[1]);
}
export function removeNegativeZero(x) {
    return Object.is(x, -0) ? 0 : x;
}
export const get = (obj, path) => path?.split(".").reduce((acc, key) => acc?.[key], obj);
//# sourceMappingURL=utils.js.map